import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ExecutionContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var HttpInfoClass;
function HttpInfo() {
  if (HttpInfoClass === VOID) {
    class $ {
      constructor(startMillis, endMillis, statusCode, headers) {
        this.p69_1 = startMillis;
        this.q69_1 = endMillis;
        this.r69_1 = statusCode;
        this.s69_1 = headers;
      }
      m3() {
        return Key_instance;
      }
    }
    protoOf($).c47 = get;
    protoOf($).d47 = fold;
    protoOf($).e47 = minusKey;
    protoOf($).t44 = plus;
    initMetadataForClass($, 'HttpInfo', VOID, VOID, [Element()]);
    HttpInfoClass = $;
  }
  return HttpInfoClass;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  HttpInfo as HttpInfo25xgxbxy3emkc,
};
//endregion

//# sourceMappingURL=HttpExecutionContext.mjs.map
